module.exports = ".message-preview{border-style:solid;border-width:1px;border-color:#dee2e6}.message-preview .content{padding:1rem}select{margin-left:1rem}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/faq.modal/faq.modal.sass
// module id = ./src/app/modules/faq.modal/faq.modal.sass
// module chunks = main